module.exports = __webpack_public_path__ + "img/icon7.2f69b139.png";